import React from 'react';
import { IconProps } from '.';

const SvgEyeOff = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 5.75c-.985 0-1.9.184-2.743.491l-.514-1.41A9.459 9.459 0 0 1 12 4.252c3.47 0 6.152 1.907 7.924 3.726a18.065 18.065 0 0 1 2.555 3.344 10.358 10.358 0 0 1 .172.306l.01.018.003.006v.002c.001 0 .002.001-.664.347l.665.346-.001.003-.003.006-.01.018-.036.067a16.011 16.011 0 0 1-.66 1.072 18.067 18.067 0 0 1-2.031 2.511l-1.075-1.046A16.562 16.562 0 0 0 21.138 12a16.567 16.567 0 0 0-2.289-2.977C17.211 7.342 14.893 5.75 12 5.75ZM22 12l.665.346.18-.346-.18-.346L22 12ZM2.862 12l.089-.147c.196-.32.49-.77.876-1.282.777-1.03 1.911-2.29 3.36-3.264l-.836-1.245C4.716 7.16 3.466 8.558 2.629 9.668c-.42.557-.74 1.047-.957 1.401a12.917 12.917 0 0 0-.312.538l-.018.033-.005.01-.002.002v.002L2 12l-.665-.347-.18.347.18.346L2 12l-.666.346.001.001.001.002.003.006.01.018a7.285 7.285 0 0 0 .172.306 18.068 18.068 0 0 0 2.555 3.344C5.848 17.842 8.53 19.75 12 19.75c2.234 0 4.144-.792 5.688-1.838l-.841-1.242c-1.362.922-2.983 1.58-4.847 1.58-2.893 0-5.211-1.592-6.85-3.273A16.564 16.564 0 0 1 2.863 12Zm-.197-.346Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.42 10.398a2.25 2.25 0 0 0 3.08 3.28l1 1.117A3.75 3.75 0 0 1 9.367 9.33l1.053 1.069Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='m20.47 21.53-18-18 1.06-1.06 18 18-1.06 1.06Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgEyeOff;
